import api from '../../utils/api';
import { ActivityType } from '../../types/actorManagement';

const authEndpoint: string = `${process.env.REACT_APP_ENDPOINT}/actor-management/activity-type`;
const fetchAllWithPaginate = () => {
  return api.get(`${authEndpoint}`);
};
const fetchAll = () => {
  return api.get(`${authEndpoint}`);
};
const fetchOne = (id: number) => {
  return api.get(`${authEndpoint}/${id}`);
};

const create = (data: ActivityType) => {
  return api.post(`${authEndpoint}`, data);
};

const update = (id: number, data: ActivityType) => {
  return api.put(`${authEndpoint}/${id}`, data);
};
const destroy = (id: number) => {
  return api.delete(`${authEndpoint}/${id}`);
};

export default {
  fetchAllWithPaginate,
  fetchAll,
  fetchOne,
  create,
  update,
  destroy
};
